
import { Options, Vue } from "vue-class-component";
import { ToastStore } from "@/store/index";

@Options({
  components: {},
  props: {},
})
export default class Toast extends Vue {
  declare $refs: {
    toast: HTMLElement;
  };

  timeoutRef?: number;
  message: string = "";
  toastUnwatch!: Function;

  isOpen(): boolean {
    return this.$refs.toast?.classList.contains("show");
  }

  open(message: string, ms: number = 3000) {
    this.message = message;

    // make sure we reset the timeout timer since it's already open
    if (this.isOpen()) this.clearTimeout();

    this.$refs.toast?.classList.add("show");

    this.timeoutRef = setTimeout(() => {
      this.timeoutRef = undefined;
      this.close();
    }, ms);
  }

  close() {
    this.$refs.toast?.classList.remove("show");
    if (this.timeoutRef) this.clearTimeout();
  }

  private clearTimeout() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = undefined;
  }

  mounted() {
    this.toastUnwatch = ToastStore.$watch(
      (module) => {
        return module.opens;
      },
      (value, legacyValue) => {
        const options = ToastStore.options;
        this.open(options.message, options.ms);
      }
    );
  }

  unmounted() {
    if (this.toastUnwatch)
        this.toastUnwatch();
  }
}
